import { render, staticRenderFns } from "./ModelEditor.vue?vue&type=template&id=ee023daa&scoped=true&"
import script from "./ModelEditor.vue?vue&type=script&lang=js&"
export * from "./ModelEditor.vue?vue&type=script&lang=js&"
import style0 from "./ModelEditor.vue?vue&type=style&index=0&id=ee023daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee023daa",
  null
  
)

export default component.exports